import { render, staticRenderFns } from "./simple_viewer.vue?vue&type=template&id=5dd8034e&vue3"
import script from "./simple_viewer.vue?vue&type=script&lang=js&vue3"
export * from "./simple_viewer.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports